var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rt-container mobile-matrix-select" },
    _vm._l(_vm.table.rows, function (row) {
      return _c(
        "div",
        { key: row.id, staticClass: "card" },
        [
          _c("van-cell", {
            staticClass: "block-title",
            attrs: { title: row.label },
          }),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.multiple
                ? [
                    _c(
                      "van-checkbox-group",
                      {
                        attrs: { direction: "horizontal" },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.dataValue[row.id],
                          callback: function ($$v) {
                            _vm.$set(_vm.dataValue, row.id, $$v)
                          },
                          expression: "dataValue[row.id]",
                        },
                      },
                      _vm._l(_vm.table.columns, function (col) {
                        return _c(
                          "van-checkbox",
                          {
                            key: col.id,
                            attrs: { name: col.label, shape: "square" },
                          },
                          [_vm._v(" " + _vm._s(col.label) + " ")]
                        )
                      }),
                      1
                    ),
                  ]
                : [
                    _c(
                      "van-radio-group",
                      {
                        attrs: { direction: "horizontal" },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.dataValue[row.id],
                          callback: function ($$v) {
                            _vm.$set(_vm.dataValue, row.id, $$v)
                          },
                          expression: "dataValue[row.id]",
                        },
                      },
                      _vm._l(_vm.table.columns, function (col) {
                        return _c(
                          "van-radio",
                          { key: col.id, attrs: { name: col.label } },
                          [_vm._v(" " + _vm._s(col.label) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }